import {ChangeDetectorRef, Component, DestroyRef, OnInit, inject} from '@angular/core';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet} from "@angular/router";
import {SidenavComponent} from "./sidenav/sidenav.component";
import {NavComponent} from "./nav/nav.component";
import {BreadComponent} from "./bread/bread.component";
import {MenuItem} from "primeng/api";
import {PanelModule} from "primeng/panel";
import {ScrollPanelModule} from "primeng/scrollpanel";
import {CardModule} from "primeng/card";
import {StyleClassModule} from "primeng/styleclass";
import {BlockUIModule} from "primeng/blockui";
import {CommonService} from "../core/service/common.service";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {ProgressBarModule} from "primeng/progressbar";
import {AsyncPipe, NgIf} from "@angular/common";
import {Toast} from "primeng/toast";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'app-app.layout',
  standalone: true,
  imports: [
    RouterOutlet,
    SidenavComponent,
    NavComponent,
    PanelModule,
    ScrollPanelModule,
    CardModule,
    StyleClassModule,
    BlockUIModule,
    ProgressSpinnerModule,
    ProgressBarModule,
    NgIf,
    Toast,
    TranslatePipe,
  ],
  templateUrl: './app.layout.component.html',
  styleUrl: './app.layout.component.css'
})


export class AppLayoutComponent implements OnInit{
    private readonly router = inject(Router);
    private readonly destroyRef = inject(DestroyRef);

    breadItems : MenuItem[] | undefined;
    /** Anything in flight — shows the thin progress bar. */
    loading : boolean = false;
    /** A save in flight — covers the page. */
    blocking : boolean = false;
    /** Between clicking a side-nav link and the page opening (lazy chunk download, guards). */
    navigating : boolean = false;

    constructor(public commonService: CommonService,
    private cdr:ChangeDetectorRef) {
    }

    ngOnInit() {

      this.commonService.loading$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value => {
        this.loading = value;
        this.cdr.detectChanges()
      });

      this.commonService.blocking$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value => {
        this.blocking = value;
        this.cdr.detectChanges()
      });

      this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => {
        if (event instanceof NavigationStart) {
          this.navigating = true;
        } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
          this.navigating = false;
        } else {
          return;
        }
        this.cdr.detectChanges();
      });

    }


}
